import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "area-label" }
const _hoisted_2 = {
  key: 0,
  class: "label-text"
}
const _hoisted_3 = ["value", "placeholder", "disabled", "maxlength"]
const _hoisted_4 = {
  key: 1,
  class: "error-text"
}

import { computed } from "vue";

export interface Props {
  modelValue: string;
  label?: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  maxlength?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTextarea',
  props: {
    modelValue: {},
    label: {},
    placeholder: {},
    error: {},
    disabled: { type: Boolean },
    maxlength: {}
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const areaClasses = computed(() => ({ error: !!props.error }));

const changeValue = (e: Event) => {
  const element = e.target as HTMLTextAreaElement;
  emit("update:model-value", element.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("textarea", {
      class: _normalizeClass(["text-area", areaClasses.value]),
      value: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      maxlength: _ctx.maxlength,
      onInput: changeValue
    }, null, 42, _hoisted_3),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})